var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 109,
    viewBox: "0 0 135 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96703 0C1.32841 0 0 1.32795 0 2.96599V106.034C0 107.672 1.32841 109 2.96703 109H132.033C133.672 109 135 107.672 135 106.034V2.96599C135 1.32795 133.672 0 132.033 0H2.96703Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4019 47.0865C76.4019 48.9291 77.8958 50.4232 79.7406 50.4232C81.5854 50.4232 83.08 48.9291 83.08 47.0865C83.08 45.2431 81.5854 43.7483 79.7406 43.7483C77.8966 43.7483 76.4019 45.2424 76.4019 47.0865ZM52.7491 65.2509H81.6439C82.4339 65.2509 82.7128 64.5413 82.2641 63.8903L71.7266 48.4242C71.2764 47.7731 70.4983 47.7427 69.9969 48.353L65.9446 53.2884C65.4417 53.8994 64.5753 53.9505 64.0183 53.3885L62.3311 51.709C61.774 51.1469 60.9462 51.2626 60.4915 51.9092L52.1401 63.8962C51.6846 64.5443 51.9591 65.2509 52.7491 65.2509Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user_default.c5df0e49dbd2cefe03c0e314662b565a.svg";
export { ForwardRef as ReactComponent };